import { useState, useEffect } from 'react';
import NavBarSmall from './NavBarSmall';
import NavBarLarge from './NavBarLarge';

export default function NavBar() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isSmallScreen ? <NavBarSmall /> : <NavBarLarge />;
}
